export default "__VITE_ASSET__Cel5QRys__"